import { useSelector } from "@grandvisionhq/state";
import { getShippingDetails } from "../../../../../../../../../../StepShipping/StepShipping/selectors.js";
import { useCheckoutSettings } from "../../../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useRequiredContactFields = () => {
  const shippingDetails = useSelector(getShippingDetails);
  const { features } = useCheckoutSettings();
  if (!shippingDetails?.expressCheckout?.isEnabled) {
    return [];
  }
  let requiredContactFields = [
    "email",
    "postalAddress",
    "name",
    "phone"
  ];
  if (typeof features?.phoneNumberRequired === "boolean" && !features?.phoneNumberRequired) {
    requiredContactFields = requiredContactFields.filter((formField) => formField !== "phone");
  }
  return requiredContactFields;
};
export {
  useRequiredContactFields
};
//# sourceMappingURL=use-required-contact-fields.js.map
